import React from "react";
import { useInventoryTable } from "../../features/adminInventory/useInventoryTable";
import useAdminInventoryStore from "../../store/useAdminInventoryStore";
import InventoryRow from "./InventoryRow";
import Pagination from "../Pagination";

const InventoryTabale = () => {
  const { data, isLoading, isError } = useInventoryTable();
  const page = useAdminInventoryStore((state) => state.page);
  const setPage = useAdminInventoryStore((state) => state.setPage);
  const pageSize = useAdminInventoryStore((state) => state.pageSize);

  const results = data?.results || [];
  const count = data?.count || 0;
  const totalPages = Math.ceil(count / (pageSize || 10));

  if (isLoading) {
    return (
      <div className="rounded-2xl border border-gray-200 bg-white p-6 text-center text-sm text-gray-500 shadow-sm">
        در حال دریافت اطلاعات موجودی...
      </div>
    );
  }

  if (isError) {
    return (
      <div className="rounded-2xl border border-red-200 bg-red-50 p-6 text-center text-sm text-red-600 shadow-sm">
        خطا در دریافت لیست موجودی
      </div>
    );
  }

  return (
    <div className="min-w-0 w-full overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
      <div className="flex flex-col gap-2 border-b border-gray-100 px-4 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-5">
        <h2 className="text-sm font-semibold text-gray-800 sm:text-base">
          لیست موجودی
        </h2>

        <span className="text-xs text-gray-500 sm:text-sm">
          تعداد کل: {count.toLocaleString("fa-IR")}
        </span>
      </div>

      <div className="w-full overflow-x-auto">
        <table className="w-full min-w-[1100px] text-right text-sm text-gray-700">
          <thead className="bg-gray-50 text-xs font-medium text-gray-600">
            <tr className="border-b border-gray-100">
              <th className="whitespace-nowrap px-2 py-3.5">عکس</th>
              <th className="whitespace-nowrap px-2 py-3.5">اطلاعات کالا</th>
              <th className="whitespace-nowrap px-2 py-3.5">تأمین‌کننده</th>
              <th className="whitespace-nowrap px-2 py-3.5">انبار</th>
              <th className="whitespace-nowrap px-2 py-3.5">موجودی</th>
              <th className="whitespace-nowrap px-2 py-3.5">قیمت</th>
              <th className="whitespace-nowrap px-2 py-3.5">تخفیف</th>
              <th className="whitespace-nowrap px-2 py-3.5">حداقل سفارش</th>
              <th className="whitespace-nowrap px-2 py-3.5">حداکثر سفارش</th>
              <th className="whitespace-nowrap px-2 py-3.5">ضریب سفارش</th>
              <th className="whitespace-nowrap px-2 py-3.5">وضعیت موجودی</th>
            </tr>
          </thead>

          <tbody>
            {results.length > 0 ? (
              results.map((item) => (
                <InventoryRow
                  key={item.inventory_id || item.id}
                  item={item}
                />
              ))
            ) : (
              <tr>
                <td
                  colSpan="11"
                  className="px-4 py-10 text-center text-sm text-gray-500"
                >
                  داده‌ای برای نمایش وجود ندارد
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="border-t border-gray-100 px-4 py-4 sm:px-5">
        <Pagination
          page={page}
          setPage={setPage}
          totalPages={totalPages}
        />
      </div>
    </div>
  );
};

export default InventoryTabale;
